import React from "react";
import classNames from "classnames";
import styles from "./TextField.module.scss";
import { Field, FieldProps } from "formik";
import InputFeedback from "components/shared/ui/form-elements/InputFeedback";
import {
  IInput,
  IInputField
} from "components/shared/ui/form-elements/FormikElements";

const TextInput = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled,
  error,
  touched,
  name,
  required = false,
  autoFocus = false,
  type = "text",
  autoComplete,
  className,
  alternative
}: IInput) => (
  <div className={classNames(className, error && touched && styles.error)}>
    <label htmlFor={name} style={{ display: "block" }} className={styles.label}>
      {label}
    </label>
    <div className={styles.inputWrapper}>
      <input
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        className={classNames(styles.input, alternative && styles.alternative)}
      />
    </div>
    <InputFeedback error={error} visible={!!error && !!touched} />
  </div>
);

export const TextField = (props: IInputField) => (
  <Field
    name={props.name}
    render={({
      field: { name, value, onChange, onBlur },
      form: { touched, errors, submitCount }
    }: FieldProps) => (
      <TextInput
        {...props}
        error={submitCount > 0 && errors[name]}
        touched={touched[name]}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
    )}
  />
);

export default TextInput;
